<mat-card>{{'addUserMobile' | translate}}</mat-card>


<mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'fullName' | translate}}</mat-label>
            <input matInput [(ngModel)]="customerRegister.fullName">
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'email' | translate}}</mat-label>
            <input matInput [(ngModel)]="customerRegister.email" required #email="ngModel">
            <mat-error *ngIf="email.invalid">{{'requiredField' | translate}}</mat-error>
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'mobileNo' | translate}}</mat-label>
            <input matInput [(ngModel)]="customerRegister.phoneNumber" required #phoneNumber="ngModel">
            <mat-error *ngIf="phoneNumber.invalid">{{'requiredField' | translate}}</mat-error>
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field appearance="standard">
            <mat-label>{{'password' | translate}}</mat-label>
            <input matInput type="password" name="pass" autocomplete="off" [(ngModel)]="customerRegister.password" required #password="ngModel">
            <mat-error *ngIf="password.invalid">{{'requiredField' | translate}}</mat-error>
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  
  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'confirmPassword' | translate}}</mat-label>
            <input matInput type="password" name="cpass" autocomplete="off" [(ngModel)]="confirmPassword" required #confirmPass="ngModel">
            <mat-error *ngIf="confirmPass.invalid">{{'requiredField' | translate}}</mat-error>
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px" >
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'balance' | translate}}</mat-label>
            <input matInput type="number" name="bal" autocomplete="off" [(ngModel)]="customerRegister.ballance">
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'userCatg' | translate}}</mat-label>
            <mat-select [(value)]="customerRegister.categoryId">
              <mat-option *ngFor="let item of userCategory" [value]="item.id">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>


  
  <mat-grid-list cols="4" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
       
        <button mat-raised-button color="primary" (click)="submit()" 
        [disabled]="email.invalid || phoneNumber.invalid || password.invalid || confirmPass.invalid">
            <mat-icon>done</mat-icon>
            {{'submit' | translate}}</button>
    </mat-grid-tile>
  </mat-grid-list>

  <app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
